export default __webpack_public_path__ + "static/media/carIcon.e6336a5d.svg";